import { Model } from '@models/core/base.model';

export class JobIndeedIntegration extends Model {
    protected static _type = 'indeedIntegrations';

    get jobId(): number {
        return this._attributes['jobId'];
    }

    get sourcePostingId(): string {
        return this._attributes['sourcePostingId'];
    }

    get employerJobId(): string | null {
        return this._attributes['employerJobId'];
    }

    get publicUrl(): string | null {
        return this._attributes['publicUrl'];
    }
}
